import { FC, useState } from 'react';

import IntroInterests from './intro-interests/intro-interests';
import SelectInterestsContainer from './select-interests-container';
import { isFeatureEnabled } from 'stores/features-list-store';
import { restrictions } from 'state/features-list/constants';

type Props = {
  onSkip: () => void;
  skipIntro?: boolean;
};

const InterestsContainer: FC<Props> = ({ onSkip, skipIntro }: Props) => {
  const [showInterests, setShowInterests] = useState(!!skipIntro);
  const isLeagueEnabled = isFeatureEnabled(restrictions.care_pathways);

  return (
    <section data-testid='interests-container'>
      {!showInterests ? (
        <IntroInterests
          onSkip={onSkip}
          onSetInterests={() => setShowInterests(true)}
        />
      ) : (
        <SelectInterestsContainer
          onFinish={onSkip}
          dontSaveLocally={isLeagueEnabled}
        />
      )}
    </section>
  );
};

export default InterestsContainer;
